import globalErrorHandler from "./globalErrorHandler";
import {ITrip} from "../types/Trip";
import {axiosClient} from "./axios";
import {ApiResponse} from "./ApiResponse";
import {DriverFormData} from "../types/Driver";

export const getTrips = (page?: number,) => new Promise<ApiResponse<ITrip[]>>(async (resolve, reject) => {
    const axios = await axiosClient()
    return axios.get('/trips?page=' + page).then(value => resolve(value.data as ApiResponse<ITrip[]>))
        .catch(err => globalErrorHandler(err, reject));
})


export const deleteTrip = (id: string,) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.delete('/trips/' + id).then(value => resolve())
        .catch(err => globalErrorHandler(err, reject))
})